import { TagSeverityType } from "primereact/tag"
import { TableOptions } from "./types";

export const statusType: Record<string, { value: string, severity: TagSeverityType }> = {
  TODO: { value: "To Do", severity: "info" },
  IN_PROGRESS: { value: "In Progress", severity: "warning" },
  DONE: { value: "Done", severity: "success" },
  CANCELLED: { value: "Cancelled", severity: "danger" },
}

export const priorityType: Record<string, { value: string, severity: string, icon: string }> = {
  HIGHEST: { value: "Highest", severity: "red", icon: "pi pi-angle-double-up" },
  HIGH: { value: "High", severity: "red", icon: "pi pi-angle-up" },
  MEDIUM: { value: "Medium", severity: "orange", icon: "pi pi-bars" },
  LOW: { value: "Low", severity: "blue", icon: "pi pi-angle-down" },
  LOWEST: { value: "Lowest", severity: "blue", icon: "pi pi-angle-double-down" },
}
export const measurementOrder = ["Darbo valandos", "Q", "V", "T1", "T2", "P", "D", "Klaida"];


export const STATUS_UPDATE_TIME = 60 * 1000;

export const ENUM_OPS = ["EQ", "NEQ", "IS_BLANK", "NOT_BLANK"];
export const NUM_OPS = ["EQ", "NEQ", "GT", "GTE", "LT", "LTE"];

export const initialFilter: TableOptions = {
  first: 0,
  rows: 10,
  page: 1,
  sortField: "",
  sortOrder: 1,
  multiSortMeta: [],
  filters: {},
  filter: null,
  andFilters: [],
  search: "",
  reqSortField: "",
};